import classNames from "classnames";

import { AscButton } from "../../components";
import AscHeading from "../../components/AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../components/AscTypography/AscParagraph/AscParagraph";
import AscAuthFlowLayout from "../AscAuthFlowLayout/AscAuthFlowLayout";
import AscLogo from "../../components/AscLogo/AscLogo";
import AscImage from "../../components/AscImage/AscImage";
import styles from "./AscEmailSentView.module.scss";
import AuthSideImage from "../../assets/images/auth-side-img.webp";
import { useResponsive } from "../../lib";

export interface AscEmailSentViewProps {
  className?: string;
  onBack?: () => void;
  onResendEmail?: () => void;
  loading?: boolean;
}

export default function AscEmailSentView({
  className,
  onBack,
  onResendEmail,
  loading,
}: AscEmailSentViewProps) {
  const { isMedium } = useResponsive();
  return (
    <AscAuthFlowLayout
      alignment="right"
      roundSideImage
      contentClassName={styles.contentWrapper}
      logoClassName={styles.hideLogo}
    >
      <div
        data-testid="asc-email-sent-view"
        className={classNames(styles.ground, className)}
      >
        {!isMedium && (
          <header className={styles.mobileHeader}>
            <AscLogo
              href={null}
              className={styles.mobileHeaderLogo}
              variant="white"
            />
            <AscImage
              className={styles.mobileHeaderBg}
              src={AuthSideImage}
              alt="App logo"
            />
          </header>
        )}
        <div className={styles.content}>
          <main className={styles.main}>
            <AscHeading className={styles.title} level={1}>
              Welcome!
            </AscHeading>
            <AscParagraph className={styles.subTitle}>
              Check your email for a verification link
            </AscParagraph>
          </main>

          <footer className={styles.footer}>
            <AscButton
              className={styles.footerButton}
              variant="secondary"
              size="large"
              onClick={onBack}
            >
              Back
            </AscButton>
            <AscButton
              className={styles.footerButton}
              variant="primary"
              size="large"
              onClick={onResendEmail}
              loading={loading}
            >
              Resend email
            </AscButton>
          </footer>
        </div>
      </div>
    </AscAuthFlowLayout>
  );
}
